<template>
  <div>
    <!-- Page Content -->
    <div class="content">
      <!-- Full Table -->
      <base-block rounded title="Question List">
        <div
          class="text-right"
          v-if="$store.getters.userDetails.includes('CAN_ADD_QUESTION')"
        >
          <b-button
            variant="success"
            href="/#/backend/forms/add-group-questions"
            >+ Add Group Question</b-button
          >
        </div>
        <br />
        <div
          class="text-right"
          v-if="$store.getters.userDetails.includes('CAN_ADD_QUESTION')"
        >
          <b-button variant="success" href="/#/backend/forms/add-bulk-questions"
            >+ Add Bulk Question</b-button
          >
        </div>
        <br />
        <div
          class="text-right"
          v-if="$store.getters.userDetails.includes('CAN_ADD_QUESTION')"
        >
          <b-button variant="success" href="/#/backend/forms/add-question"
            >+ Add Question</b-button
          >
        </div>
        <br />
        <div class="d-flex justify-content-end mb-2">
          <input
            class="form-control"
            type="text"
            v-model="search"
            placeholder="Search..."
            aria-label="Search"
            style="width: 300px"
            @keyup="
              (pageSelected = 1), (rowsAndFiltersClicked = true), getQuestions()
            "
          />
        </div>
        <div class="row mb-2">
          <div class="col-md-3">
            <b-form-select
              class="form-control"
              v-model="rows"
              @change="
                (pageSelected = 1),
                  (rowsAndFiltersClicked = true),
                  getQuestions()
              "
            >
              <b-form-select-option value="10">10</b-form-select-option>
              <b-form-select-option value="25">25</b-form-select-option>
              <b-form-select-option value="50">50</b-form-select-option>
              <b-form-select-option value="100">100</b-form-select-option>
            </b-form-select>
          </div>

          <div class="col-md-3">
            <b-form-select
              class="form-control"
              v-model="parentTopic"
              @change="
                getTopics(),
                  (pageSelected = 1),
                  (rowsAndFiltersClicked = true),
                  getQuestions()
              "
            >
              <b-form-select-option value=""
                >Select Parent Topic</b-form-select-option
              >
              <b-form-select-option
                :value="parentTopic.id"
                v-for="(parentTopic, index) in parentTopics"
                :key="index"
                >{{ parentTopic.name }}</b-form-select-option
              >
            </b-form-select>
          </div>

          <div class="col-md-3">
            <b-form-select
              class="form-control"
              v-model="topic"
              @change="
                getSubtopics(),
                  (pageSelected = 1),
                  (rowsAndFiltersClicked = true),
                  getQuestions()
              "
            >
              <b-form-select-option value="">Select Topic</b-form-select-option>
              <b-form-select-option
                :value="topic.id"
                v-for="(topic, index) in topics"
                :key="index"
                >{{ topic.name }}</b-form-select-option
              >
            </b-form-select>
          </div>

          <div class="col-md-3">
            <b-form-select
              class="form-control"
              v-model="subtopic"
              @change="
                (pageSelected = 1),
                  (rowsAndFiltersClicked = true),
                  getQuestions()
              "
            >
              <b-form-select-option value=""
                >Select Subtopic</b-form-select-option
              >
              <b-form-select-option
                :value="subtopic.id"
                v-for="(subtopic, index) in subtopics"
                :key="index"
                >{{ subtopic.name }}</b-form-select-option
              >
            </b-form-select>
          </div>
        </div>
        <b-table-simple responsive bordered striped table-class="table-vcenter">
          <b-thead>
            <b-tr>
              <b-th class="text-center">S.NO</b-th>
              <b-th class="text-center" style="min-width: 300px">Question</b-th>
              <b-th class="text-center">Parent Topic</b-th>
              <b-th class="text-center">Topic</b-th>
              <b-th class="text-center">Sub Topic</b-th>
              <b-th class="text-center">Question Image</b-th>
              <b-th class="text-center">Type</b-th>
              <b-th class="text-center">Answer</b-th>
              <b-th class="text-center">Options</b-th>
              <b-th
                class="text-center"
                v-if="
                  $store.getters.userDetails.includes('CAN_STATUS_QUESTION')
                "
                >Status</b-th
              >
              <b-th
                class="text-center"
                v-if="
                  $store.getters.userDetails.includes('CAN_EDIT_QUESTION') ||
                    $store.getters.userDetails.includes(
                      'CAN_DELETE_QUESTION'
                    ) ||
                    $store.getters.userDetails.includes('CAN_SEE_QUESTION')
                "
                >Action</b-th
              >
            </b-tr>
          </b-thead>
          <b-tbody v-if="questions.length == 0"
            ><b-tr
              ><b-td colspan="11" class="text-center"
                >No records found</b-td
              ></b-tr
            ></b-tbody
          >
          <b-tbody v-else>
            <b-tr v-for="(question, index) in questions" :key="index">
              <b-td class="text-center">
                {{ (currentPage - 1) * rows + index + 1 }}
              </b-td>
              <b-td class="text-center" v-html="`${question.question}`"></b-td>
              <b-td class="text-center">{{
                question.topic
                  ? question.topic.subparent
                    ? question.topic.subparent.parent.name
                    : "-"
                  : "-"
              }}</b-td>
              <b-td class="text-center">{{
                question.topic
                  ? question.topic.subparent
                    ? question.topic.subparent.name
                    : "-"
                  : "-"
              }}</b-td>
              <b-td class="text-center">
                {{ question.topic.name }}
              </b-td>
              <b-td class="text-center">
                <img :src="question.image" style="width: 40px" />
              </b-td>
              <b-td class="text-center">
                {{
                  question.question_type == "objective"
                    ? "MCQ"
                    : question.question_type == "group"
                    ? "Group"
                    : question.question_type == "coding"
                    ? "Coding"
                    : "Fillups"
                }}
              </b-td>
              <b-td class="text-center">
                {{ question.answer }}
              </b-td>
              <b-td class="text-center" style="min-width: 300px">
                <span v-for="(option, index) in question.options" :key="index">
                  {{ option.option }}
                  {{ index == question.options.length - 1 ? "" : "," }}
                </span>
              </b-td>
              <b-td
                class="text-center"
                v-if="
                  $store.getters.userDetails.includes('CAN_STATUS_QUESTION')
                "
              >
                <b-button
                  :class="{ 'btn-danger': !question.status }"
                  size="sm"
                  :variant="buttonVariant"
                  @click="toggleStatus(question.id, index, question.status)"
                >
                  {{ question.status ? "Active" : "Deactive" }}
                </b-button>
              </b-td>
              <b-td
                class="text-center"
                v-if="
                  $store.getters.userDetails.includes('CAN_EDIT_QUESTION') ||
                    $store.getters.userDetails.includes(
                      'CAN_DELETE_QUESTION'
                    ) ||
                    $store.getters.userDetails.includes('CAN_SEE_QUESTION')
                "
              >
                <b-btn-group>
                  <router-link
                    :to="{
                      name:
                        question.question_type == 'group'
                          ? 'Group View'
                          : 'Mcq View',
                      params: { id: question.id },
                    }"
                  >
                    <b-button
                      size="sm"
                      variant="alt-primary"
                      v-if="
                        $store.getters.userDetails.includes('CAN_SEE_QUESTION')
                      "
                    >
                      <i class="fa fa-fw fa-eye"></i>
                    </b-button>
                  </router-link>

                  <router-link
                    :to="{
                      name:
                        question.question_type == 'group'
                          ? 'Edit Group Question'
                          : 'Edit Question',
                      params: { id: question.id },
                    }"
                  >
                    <b-button
                      size="sm"
                      variant="alt-primary"
                      v-if="
                        $store.getters.userDetails.includes('CAN_EDIT_QUESTION')
                      "
                    >
                      <i class="fa fa-fw fa-pencil-alt"></i>
                    </b-button>
                  </router-link>

                  <b-button
                    size="sm"
                    variant="alt-primary"
                    @click="deleteQuestion(question.id)"
                    v-if="
                      $store.getters.userDetails.includes('CAN_DELETE_QUESTION')
                    "
                  >
                    <i class="fa fa-fw fa-times"></i>
                  </b-button>
                </b-btn-group>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>

        <!-- pagination -->
        <div class="text-right" v-if="lastPage != 1 && questions.length > 0">
          <b-button-group>
            <b-button
              size="lg"
              variant="outline-primary"
              @click="first()"
              :disabled="
                totalPages.length > 0
                  ? totalPages[0].display
                    ? true
                    : false
                  : false
              "
              ><i class="fas fa-angle-double-left"></i
            ></b-button>
            <b-button
              size="lg"
              variant="outline-primary"
              :disabled="
                totalPages.length > 0
                  ? totalPages[0].display
                    ? true
                    : false
                  : false
              "
              @click="previousPage()"
              ><i class="fas fa-angle-left"></i
            ></b-button>
            <b-button
              :pressed="page.activeStatus == true ? true : false"
              v-show="page.display"
              :id="page.id"
              @click="buttonClick(index)"
              size="lg"
              variant="outline-primary"
              v-for="(page, index) in totalPages"
              :key="index"
              >{{ index + 1 }}</b-button
            >
            <b-button
              size="lg"
              variant="outline-primary"
              @click="nextPage()"
              :disabled="
                totalPages.length > 0
                  ? totalPages[totalPages.length - 1].display
                    ? true
                    : false
                  : false
              "
              ><i class="fas fa-angle-right"></i
            ></b-button>
            <b-button
              size="lg"
              variant="outline-primary"
              @click="last()"
              :disabled="
                totalPages.length > 0
                  ? totalPages[totalPages.length - 1].display
                    ? true
                    : false
                  : false
              "
              ><i class="fas fa-angle-double-right"></i
            ></b-button>
          </b-button-group>
        </div>
        <!-- End pagination -->

        <br />

        <!-- Loader -->
        <b-overlay
          :show="loader"
          no-wrap
          blur="2px"
          opacity="0.60"
          class="position-fixed"
        >
          <template #overlay>
            <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
          </template>
        </b-overlay>
        <!-- End Loader -->
      </base-block>
      <!-- END Full Table -->
    </div>
    <!-- END Page Content -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      rowsAndFiltersClicked: false,
      search: "",
      parentTopics: [],
      parentTopic: "",
      topics: [],
      topic: "",
      subtopics: [],
      subtopic: "",
      firstDisableStatus: false,
      lastDisableStatus: false,
      rows: 10,
      pageSelected: "",
      currentPage: "",
      lastPage: "",
      totalPages: [],
      loader: false,
      buttonVariant: "success",
      questions: [],
    };
  },
  mounted: async function() {
    await this.getQuestions();
    this.getParentTopics();
    this.pagination();
  },
  watch: {
    questions: function() {
      if ("MathJax" in window) {
        this.$nextTick(function() {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
            console.log("done")
          );
        });
      }
    },
  },
  methods: {
    buttonClick(index) {
      this.latex = this.latex + 1;
      this.totalPages = this.totalPages.map((ele) => {
        if (ele.activeStatus == true) {
          ele.activeStatus = false;
        }
        return ele;
      });
      this.totalPages[index].activeStatus = true;
      let displayedPages = this.totalPages.filter((ele) => ele.display == true);
      if (displayedPages[0] === this.totalPages[index]) {
        if (
          this.totalPages[0].display == false &&
          this.totalPages[1].display == false
        ) {
          this.totalPages[index - 1].display = true;
          this.totalPages[index - 2].display = true;
          this.totalPages[index + 3].display = false;
          this.totalPages[index + 4].display = false;
        }
        if (
          this.totalPages[0].display == false &&
          this.totalPages[1].display == true
        ) {
          this.totalPages[index - 1].display = true;
          this.totalPages[index + 4].display = false;
        }
      }
      if (displayedPages[1] === this.totalPages[index]) {
        if (
          this.totalPages[0].display == false &&
          this.totalPages[1].display == false
        ) {
          this.totalPages[index - 2].display = true;
          this.totalPages[index + 3].display = false;
        }
      }
      if (displayedPages[3] === this.totalPages[index]) {
        if (
          this.totalPages[this.totalPages.length - 1].display == false &&
          this.totalPages[this.totalPages.length - 2].display == false
        ) {
          this.totalPages[index + 2].display = true;
          this.totalPages[index - 3].display = false;
        }
      }
      if (displayedPages[4] === this.totalPages[index]) {
        if (
          this.totalPages[this.totalPages.length - 1].display == false &&
          this.totalPages[this.totalPages.length - 2].display == false
        ) {
          this.totalPages[index + 1].display = true;
          this.totalPages[index + 2].display = true;
          this.totalPages[index - 3].display = false;
          this.totalPages[index - 4].display = false;
        }
        if (
          this.totalPages[this.totalPages.length - 1].display == false &&
          this.totalPages[this.totalPages.length - 2].display == true
        ) {
          this.totalPages[index + 1].display = true;
          this.totalPages[index - 4].display = false;
        }
      }
      this.pageSelected = this.totalPages[index].id.split(" ")[1];
      this.getQuestions();
    },
    last() {
      this.totalPages = this.totalPages.map((ele) => {
        if (ele.activeStatus == true) {
          ele.activeStatus = false;
        }
        return ele;
      });
      this.totalPages[this.totalPages.length - 1].activeStatus = true;
      for (var i = 0; i < this.totalPages.length; i++) {
        this.totalPages[i].display = false;
      }
      if (this.lastPage + 1 > 5) {
        for (var j = 0; j < 5; j++) {
          this.totalPages[this.totalPages.length - 1 - j].display = true;
        }
      } else {
        for (var k = 0; k < this.totalPages.length; k++) {
          this.totalPages[this.totalPages.length - 1 - k].display = true;
        }
      }
      this.pageSelected = this.totalPages.length;
      this.getQuestions();
    },
    first() {
      this.totalPages = this.totalPages.map((ele) => {
        if (ele.activeStatus == true) {
          ele.activeStatus = false;
        }
        return ele;
      });
      this.totalPages[0].activeStatus = true;
      for (var i = 0; i < this.totalPages.length; i++) {
        this.totalPages[i].display = false;
      }
      for (var j = 0; j < 5; j++) {
        this.totalPages[j].display = true;
      }
      this.pageSelected = 1;
      this.getQuestions();
    },
    previousPage() {
      var displayedPages = this.totalPages.filter((ele) => ele.display == true);
      let first = this.totalPages.indexOf(displayedPages[0]);
      let last = this.totalPages.indexOf(
        displayedPages[displayedPages.length - 1]
      );
      this.totalPages[first - 1].display = true;
      this.totalPages[last].display = false;
      this.totalPages = this.totalPages.map((ele, index, totalArray) => {
        if (ele.activeStatus == true) {
          ele.activeStatus = false;
          totalArray[index - 1].activeStatus = true;
        }
        return ele;
      });
      let currentPage = this.totalPages.find((ele) => ele.activeStatus == true);
      this.pageSelected = currentPage.id.split(" ")[1];
      this.getQuestions();
    },
    nextPage() {
      var nextArrStatus = false;
      var displayedPages = this.totalPages.filter((ele) => ele.display == true);
      let first = this.totalPages.indexOf(displayedPages[0]);
      let last = this.totalPages.indexOf(
        displayedPages[displayedPages.length - 1]
      );
      this.totalPages[first].display = false;
      this.totalPages[last + 1].display = true;
      this.totalPages = this.totalPages.map((ele) => {
        var data = ele;
        if (data.activeStatus == true) {
          data.activeStatus = false;
          nextArrStatus = true;
        } else if (nextArrStatus) {
          data.activeStatus = true;
          nextArrStatus = false;
        }
        return data;
      });
      let currentPage = this.totalPages.find((ele) => ele.activeStatus == true);
      this.pageSelected = currentPage.id.split(" ")[1];
      this.getQuestions();
    },

    async deleteQuestion(id) {
      await axios
        .get(`${this.$store.getters.baseUrl}/question/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$swal("Success", "Question deleted successfully", "success");
            this.getQuestions();
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async toggleStatus(id, index, status) {
      await axios
        .get(`${this.$store.getters.baseUrl}/question/status/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.questions[index].status = status == 1 ? 0 : 1;
            this.$swal(
              "Success",
              "Question status changed successfully",
              "success"
            );
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getQuestions() {
      this.loader = true;
      let filterTopic = this.subtopic
        ? this.subtopic
        : this.topic
        ? this.topic
        : this.parentTopic
        ? this.parentTopic
        : "";
      await axios
        .get(
          `${this.$store.getters.baseUrl}/questions?page=${this.pageSelected}&row=${this.rows}&search=${this.search}&topicid=${filterTopic}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then(async (response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.questions = await response.data.questions;
            this.lastPage = response.data.pagination.last_page;
            this.currentPage = response.data.pagination.current_page;
            if (this.rowsAndFiltersClicked) {
              this.pagination();
              this.rowsAndFiltersClicked = false;
            }
            this.loader = false;
          } else {
            this.loader = false;
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    pagination() {
      if (this.lastPage + 1 > 5) {
        this.totalPages = [];
        for (var i = 1; i < this.lastPage + 1; i++) {
          this.totalPages.push({
            id: `page ${i}`,
            display: false,
            activeStatus: false,
          });
        }
        this.totalPages = this.totalPages.map((ele, index) => ({
          ...ele,
          display: index < 5,
          activeStatus: index == 0,
        }));
      } else {
        this.totalPages = [];
        for (var j = 1; j < this.lastPage + 1; j++) {
          this.totalPages.push({
            id: `page ${j}`,
            display: false,
            activeStatus: false,
          });
        }
        this.totalPages = this.totalPages.map((ele, index) => ({
          ...ele,
          display: true,
          activeStatus: index == 0,
        }));
      }
    },

    async getParentTopics() {
      await axios
        .get(`${this.$store.getters.baseUrl}/topics`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then(async (response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.parentTopics = await response.data.topics;
            this.loader = false;
          } else {
            this.loader = false;
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getTopics() {
      (this.topic = ""), (this.subtopic = "");
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${this.parentTopic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.topics = response.data.topics;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getSubtopics() {
      this.subtopic = "";
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${this.topic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.subtopics = response.data.topics;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>
